<template>
<v-dialog
    v-model="dialog"
    max-width="800"
>
    <v-card>
    <v-card-title class="headline">{{label}}</v-card-title>

    <v-card-text>
        
        <v-select
            :label="label"
            :items="possible_values"
            v-model="value"
            :return-object="!multiple && returnObject"
            :multiple="multiple"
            :chips="chips"
        />
        
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    props: {
        multiple: {
            type: Boolean,
            default: function() { return false; },
        },

        chips: {
            type: Boolean,
            default: function() { return false; },
        },

        'return-object': {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return {
            dialog: false,
            label: 'field',
            value: { 'text' : 'Some value' },
            possible_values: [],
        }
    },

    methods: {
        showDialog(label, value, possible_values) 
        {
            this.label = label;
            this.value = value;
            this.possible_values = _.cloneDeep(possible_values);
            this.dialog = true; 
        },
        
        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>